<template>
  <div class="pb-2">
    <organism-service-data-management
      v-if="filterData"
      :filterList="filterData"
      :fields="serviceTableHeader"
      :items="serviceTableData"
      @onUpdateFilterData="onUpdateFilterData"
      @onSetDefaultFilterData="onSetDefaultFilterData"
      @onUpdateCurrentPage="onUpdateCurrentPage"
    ></organism-service-data-management>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { getAllServices } from "@/api/api-module1"
import OrganismServiceDataManagement from "@/components/organisms/globalSetting/dataManagement/service/OrganismServiceDataManagement.vue"
import mixins from "@/mixins"
import mixinsObjectHelper from '@/mixins/mixinsObjectHelper'
export default {
  name: "ServiceDataManagement",

  components: {
    OrganismServiceDataManagement,
  },

  mixins: [mixins, mixinsObjectHelper],

  data() {
    return {
      serviceTableHeader: [
        {
          key: "serviceStatus",
          label: "SERVICE STATUS",
          thClass: "w-50px",
          tdClass: "w-50px",
        },
        {
          key: "serviceName",
          label: "SERVICE NAME",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "totalPackage",
          label: "PACKAGE AMOUNT",
          thClass: "w-25px text-center",
          tdClass: "w-25px text-center",
        },
      ],
      serviceTableData: [],
      filterData: null,
    }
  },

  computed: {
    ...mapGetters("appFilter", ["getGCFServiceFilter"]),
  },

  mounted() {
    this.fetchDataFromApi()
  },

  methods: {
    ...mapActions("appFilter", ["setGCFServiceFilter"]),
    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getGCFServiceFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    async fetchDataFromApi() {
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      this.showLoading(true)
      await getAllServices(filterData)
        .then((response) => {
          const updatedFilter = {
            ...this.getGCFServiceFilter,
            totalCount: response.totalCount,
          }
          this.setGCFServiceFilter(updatedFilter)
          this.serviceTableData = response.data.map((service) => {
            return {
              serviceId: service.serviceId,
              serviceName: service.serviceName,
              serviceStatus: this.getServicePackageStatus(service.deprecated),
              totalPackage: service.packages.length,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    getServicePackageStatus(isDeprecated) {
      return isDeprecated ? "DEPRECATED" : "ACTIVE"
    },

    onUpdateCurrentPage(filter) {
      const updatedFilter = {
        ...this.getGCFServiceFilter,
        pageNumber: filter.pageNumber,
      }
      this.setGCFServiceFilter(updatedFilter)
      this.fetchDataFromApi()
    },

    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setGCFServiceFilter(filter)
      this.fetchDataFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        serviceName: "",
        statuses: ["Active"],
        pageNumber: 1,
        totalCount: 0,
      }
      this.setGCFServiceFilter(defaultFilter)
      this.fetchDataFromApi()
    },

    filterDecoration() {
      const filter = {
        serviceName: this.filterData.serviceName || undefined,
        statuses: this.filterData.statuses.length
          ? this.filterData.statuses.map((item) => item.toUpperCase())
          : undefined,
        pageNumber: this.filterData.pageNumber,
      }
      return filter
    },
  },
}
</script>

<style lang="scss" scoped></style>
